const stripTrailingSlash = (value) => String(value || '').replace(/\/+$/, '');

const runtimeOrigin = typeof window !== 'undefined'
    ? stripTrailingSlash(window.location.origin)
    : '';

export const API_BASE_URL = stripTrailingSlash(process.env.REACT_APP_API_BASE_URL || '') || runtimeOrigin;

const joinUrl = (base, path = '') => {
    if (!path) {
        return base;
    }

    const normalizedPath = String(path);
    if (/^https?:\/\//i.test(normalizedPath)) {
        return normalizedPath;
    }

    if (!base) {
        return normalizedPath.startsWith('/') ? normalizedPath : `/${normalizedPath}`;
    }

    return `${base}${normalizedPath.startsWith('/') ? normalizedPath : `/${normalizedPath}`}`;
};

export const buildApiUrl = (path = '') => joinUrl(API_BASE_URL, path);

export const buildMediaUrl = (path = '') => {
    if (!path) {
        return '';
    }

    return joinUrl(API_BASE_URL, path);
};
